import React from "react";
import { Switch } from "@headlessui/react";

type ToggleProps = {
  label: string | React.ReactNode;
  subtext?: string;
  checked: boolean;
  setChecked: (isChecked: boolean) => void;
  className?: string;
  size?: "sm" | "md";
  disabled?: boolean;
};
const Toggle = ({
  label,
  subtext,
  checked,
  setChecked,
  className = "",
  size = "md",
  disabled = false,
}: ToggleProps) => {
  let bgColor;
  if (checked) {
    bgColor = disabled ? "bg-emerald-300" : "bg-emerald-500";
  } else {
    bgColor = disabled ? "bg-gray-100" : "bg-gray-200";
  }
  return size === "md" ? (
    <div>
      <Switch.Group as="div" className={`${className} flex items-start`}>
        <Switch
          checked={checked}
          onChange={setChecked}
          disabled={disabled}
          className={`${bgColor}
          relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 disabled:cursor-default`}
        >
          <span
            aria-hidden="true"
            className={`${checked ? "translate-x-5" : "translate-x-0"}
            pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`}
          />
        </Switch>
        <Switch.Label as="span" className="ml-2">
          <span className="text-sm font-medium text-gray-900">{label} </span>
        </Switch.Label>
      </Switch.Group>
      {subtext && <p className="mt-2 text-xs text-gray-400 whitespace-pre-line">{subtext}</p>}
    </div>
  ) : (
    <div>
      <Switch.Group as="div" className={`${className} flex items-start`}>
        <Switch.Label as="span" className="mr-2 text-sm font-medium text-slate-500">
          {label}
        </Switch.Label>
        <Switch
          checked={checked}
          onChange={setChecked}
          disabled={disabled}
          className="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:cursor-default"
        >
          <span aria-hidden="true" className="pointer-events-none absolute h-full w-full rounded-md bg-white" />
          <span
            aria-hidden="true"
            className={`
            ${checked ? "bg-emerald-600" : "bg-red-500"}
            pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out`}
          />
          <span
            aria-hidden="true"
            className={`
            ${checked ? "translate-x-5" : "translate-x-0"}
            pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out`}
          />
        </Switch>
      </Switch.Group>
      {subtext && <p className="mt-2 text-xs text-gray-400 whitespace-pre-line">{subtext}</p>}
    </div>
  );
};

export default Toggle;
